import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { OpenMenu, ToggleMenu } from '../actions/menu.action';

export interface MenuStateModel {
    isOpen: boolean;
}

@State<MenuStateModel>({
    name: 'menu',
    defaults: {
        isOpen: true,
    },
})
@Injectable()
export class MenuState {
    @Selector()
    public static isOpen(state: MenuStateModel): boolean {
        return state.isOpen;
    }

    @Action(ToggleMenu)
    public toggleMenu(ctx: StateContext<MenuStateModel>): void {
        const state: MenuStateModel = ctx.getState();
        ctx.patchState({
            isOpen: !state.isOpen,
        });
    }

    @Action(OpenMenu)
    public openMenu(ctx: StateContext<MenuStateModel>): void {
        ctx.patchState({
            isOpen: true,
        });
    }
}
